/**
 * تصغير صور التخزين للعرض الفعليّ (LCP).
 *
 * روابط `storage/v1/object/public/...` تُقدَّم بالحجم الأصليّ وبلا cache طويل.
 * نقطة `storage/v1/render/image/public/...` تُرجِع نسخة بعرض محدَّد
 * (WebP حسب Accept) مع cache-control أفضل — بلا أيّ تغيير في التصميم.
 */
const OBJECT_SEG = "/storage/v1/object/public/";
const RENDER_SEG = "/storage/v1/render/image/public/";

export function storageImage(
  url: string | null | undefined,
  width: number,
  quality = 80,
): string {
  if (!url) return "";
  if (!url.includes(OBJECT_SEG)) return url;
  // لا نحوّل الفيديو
  if (/\.(mp4|webm|mov|m4v)(\?|$)/i.test(url)) return url;
  const [base, query] = url.split("?");
  const rendered = base.replace(OBJECT_SEG, RENDER_SEG);
  const params = new URLSearchParams(query ?? "");
  params.set("width", String(width));
  params.set("quality", String(quality));
  params.set("resize", "contain");
  return `${rendered}?${params.toString()}`;
}

/** srcset بعروض متعدّدة لصورة تخزين واحدة. */
export function storageSrcSet(
  url: string | null | undefined,
  widths: number[],
  quality = 80,
): string | undefined {
  if (!url || !url.includes(OBJECT_SEG)) return undefined;
  if (/\.(mp4|webm|mov|m4v)(\?|$)/i.test(url)) return undefined;
  return widths.map((w) => `${storageImage(url, w, quality)} ${w}w`).join(", ");
}
